<template>
    <div class="spin_container">
        <div v-if="(usecheckbox == true)">
            <label class="spin_value" v-if="(value == 1) || (zerotext == '')">{{nonzerotext}}</label>
            <label class="spin_value" v-else>{{zerotext}}</label>
            <input @input="val = 1 - val" :checked="value == 1" type="checkbox"/>
        </div>
        <div v-else-if="(value == 0) && (zerotext)" class="spin_value_container inline_display_class">
            <button @click="inc" class="spin-button inline_display_class"> <span class="spin_value">{{ zerotext }}</span></button>
        </div>
        <div v-else class="spin_buttons">
            <span class="spin_value" v-if="(nonzerotext != '') && (value != 0)">{{nonzerotext}}</span>
            <button @click="dec" class="edit_button inline_display_class"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg></button>
            <div class="spin_value_container inline_display_class">
                <span v-if="(!showlimit)" class="spin_value"> {{value}} </span>
                <span v-else class="spin_value"> {{value}}/{{(visualLimit) ? visualLimit : limit}} </span>
            </div>

            <button @click="inc" class="edit_button inline_display_class"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg></button>
        </div>

    </div>
</template>

<script>
export default {
    data(){
        return {
            val: 0
        }
    },
    props:['showlimit', 'zerotext', 'value', 'limit', 'displaylimit', 'usecheckbox', 'nonzerotext'],
    watch:{
        val(){
            this.$emit('input', this.val)
        }
    },
    computed:{
        visualLimit(){
            return (this.displaylimit) ? this.displaylimit : this.limit
        }
    },
    methods:{
        inc(){
            if (this.val + 1 <= this.limit)
            {
                this.val = this.val + 1
            }
        },
        dec(){
            if (this.val - 1 >= 0) {
                this.val = this.val - 1
            }
        }
    },
    mounted(){
        this.val = this.value
    }
}
</script>